import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ListaComponent } from './lista/lista.component';
import { FormularioComponent } from './formulario/formulario.component';
import { NivelesEducativosFormulariosComponent } from './niveles-educativos-formularios/formulario.component';
import { AuthGuard } from '../../auth-guard.service';

const routes: Routes = [
  {
    path: 'formulario/configuracion-formulario',
    children: [
      { path: 'lista', component: ListaComponent},
      { path: 'nuevo', component: FormularioComponent },
      { path: 'editar/:id', component: FormularioComponent}
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'formulario/nivel-educativo-formulario',
    children: [
      { path: 'editar/:id', component: NivelesEducativosFormulariosComponent },
    ],
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class FormularioRoutingModule { }

